import React from 'react';
import PropTypes from 'prop-types';

const IconReturns = ({ color = '#585858', ...otherProps }) => (
  <svg width={41} height={32} viewBox="0 0 41 32" {...otherProps}>
    <g stroke={color} strokeWidth={1.5} fill="none" fillRule="evenodd">
      <path d="M12.064 17.08L12 9.946a2.7 2.7 0 011.403-2.382l11.32-6.225a2.76 2.76 0 012.613-.023l11.218 5.92A2.695 2.695 0 0140 9.62v12.56c0 .988-.544 1.895-1.419 2.37L27.29 30.668a2.755 2.755 0 01-2.644-.012l-11.148-6.162a2.691 2.691 0 01-1.4-2.35l-.005-1.73" />
      <path d="M12 9l13.5 7L39 9.163M25.5 16v15M8 11l-6 5.5L8 22" />
      <path d="M4 16.5h13" strokeLinecap="square" />
    </g>
  </svg>
);

IconReturns.propTypes = {
  color: PropTypes.string,
};

export default IconReturns;
